/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSetupParameterTemplateListValuesEntry } from '../../models/update-setup-parameter-template-list-values-entry';

export interface UpdateSetupParameterTemplateListValues$Params {
      body: Array<UpdateSetupParameterTemplateListValuesEntry>
}

export function updateSetupParameterTemplateListValues(http: HttpClient, rootUrl: string, params: UpdateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSetupParameterTemplateListValues.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSetupParameterTemplateListValues.PATH = '/api/v1/SetupParameter/UpdateSetupParameterTemplateListValuesList';
